import { Div, Ref, TextInput, Image } from "@tblabs/truffle";
import { PicUploader } from "../../Components/Description/Gallery/PicsUploader";
import { DangerButton } from "../../Components/Utils/DangerButton";
import { PrimaryButton } from "../../Components/Utils/PrimaryButton";


export class SinglePictureEdit extends Div
{
    constructor(imageUrl: Ref<string>)
    {
        super("");

        let deleted = "";

        this.Append(
            new TextInput(imageUrl).Placeholder("Url do miniaturki obrazka"),
            
            new Image(imageUrl).Height(220).Margin(8).DisplayInlineBlock(),

            new Div().Style("margin: 8px; display: flex; flex-direction: row; gap: 8px;").Append(
            new DangerButton("Usuń")
                .OnClick((_) =>
                {
                    if (deleted == "")
                    {
                        deleted = imageUrl.value;
                        imageUrl.value = "";
                        _.Label("Cofnij")
                    }
                    else
                    {
                        imageUrl.value = deleted;
                        deleted = "";
                        _.Label("Usuń")
                    }
                }),

            new PrimaryButton(imageUrl.value ? "Zmień" : "Dodaj")
                .OnClick((_) =>
                {
                    _.RemoveSelf()
                    this.Append(
                        new PicUploader((image) =>
                        {
                            if (image.Extension == "gif")
                            {
                                imageUrl.value = image.Original;
                            }
                            else
                            {
                                imageUrl.value = image.Thumbnail;
                            }
                        }).Width(320)
                    )
                }),
            ),
        )
    }
}
